<template>
  <div
    class="page--employee"
    :style="`min-height: ${height}px`"
  >
    <Header :status="currentStatus" />

    <Form
      :submit="submitForm"
      :status="currentStatus"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer :status="currentStatus" @submit="handleSubmit" />
  </div>
</template>

<script>
import Header from 'components/pages/employeeMassCreditPolicy/Header'
import Form from 'components/pages/employeeMassCreditPolicy/Form'
import Footer from 'components/pages/employeeMassCreditPolicy/Footer'

export default {
  name: 'EmployeeMassCreditPolicy',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.EmployeeMassCreditPolicyPage',
      submitForm: false,
      currentStatus: null
    }
  },
  methods: {
    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    }
  }
}
</script>
